var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.571 22c.395 0 .715-.32.715-.714v-1.429a.715.715 0 00-.715-.714h-1.785V5.57h5.357V7c0 .394.32.714.714.714h1.429c.394 0 .714-.32.714-.714V2.714A.715.715 0 0021.286 2H2.714A.715.715 0 002 2.714V7c0 .394.32.714.714.714h1.429c.394 0 .714-.32.714-.714V5.571h5.357v13.572H8.43a.715.715 0 00-.715.714v1.429c0 .394.32.714.715.714h7.142z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/b24eecb719c7d5c38d4b214691ac1d79-text.svg";
export { SvgText as ReactComponent };